export default "__VITE_ASSET__Cx3Bo3HW__"